<template>
  <base-widget
    class="user-card"
    :title="title"
    condensed
  >
    <div class="d-flex align-content-center">
      <div class="user-card__avatar">
        <avatar-editor
          v-if="showEditor"
          ref="editor"
          :pre-filled-image="innerAvatar"
          :initial-step="innerAvatar? 1:0"
          @change-avatar="changeAvatar"
          @delete-avatar="deleteAvatar"
        />
        <base-avatar
          :readonly="!avatarEditable"
          :size="(el.is.small)? 60:86"
          :username="username"
          :img="innerAvatar"
          @click="loadImage"
        />
      </div>
      <div class="d-flex flex-column justify-content-center">
        <base-hover v-slot="{isHover}">
          <base-text
            size="m"
            trim
            max-width="200"
            class="user-card__username"
          >
            <slot
              :first="first"
              :last="last"
            >
              <base-icon
                v-if="editable && isHover"
                class="pencil"
                icon="pencil"
                @click="startEditing"
              />
              {{ first }}
              <br>
              {{ last }}
            </slot>
          </base-text>
        </base-hover>
        <base-text
          trim
          :max-width="120"
          class="user-card__subtitle"
          :size="(subtitle.length > 20)? 'xs':'s'"
          light
        >
          {{ subtitle }}
        </base-text>
      </div>
    </div>
    <div
      v-if="hasBottomSlot"
      class="user-card__bottom-slot"
    >
      <slot name="bottom" />
    </div>
  </base-widget>
</template>
<script>
import { ResponsiveMixin } from 'vue-responsive-components';

export default {
  mixins: [ResponsiveMixin],
  breakpoints: {
    small: (el) => el.width <= 220,
  },
  props: {
    title: {
      type: String,
      default: 'Profile',
    },
    username: {
      type: String,
      required: true,
    },
    first: {
      type: String,
      default: '',
    },
    last: {
      type: String,
      default: '',
    },
    avatar: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    editable: {
      type: Boolean,
      default: false,
    },
    avatarEditable: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editUsername: false,
      loading: false,
      temporaryAvatar: '', // Used when uploading a new avatar
      showEditor: false,
    };
  },
  computed: {
    hasBottomSlot() {
      return this.$slots.bottom;
    },
    innerAvatar() {
      return (this.temporaryAvatar) ? this.temporaryAvatar : this.avatar;
    },
  },
  watch: {
    isLoading(newVal) {
      this.loading = newVal;
    },
  },
  methods: {
    loadImage() {
      this.showEditor = true;
      this.$nextTick().then(() => {
        this.$refs.editor.open();
      });
    },
    changeAvatar({ file, image }) {
      this.$emit('change-avatar', file);
      this.temporaryAvatar = image;
    },
    deleteAvatar() {
      this.avatar = null;
      this.$emit('delete-avatar');
    },
    startEditing() {
      this.$emit('startEditing');
    },
  },
};
</script>
<style lang="scss" scoped>
.user-card {
  max-width: 100%;
  width: 100%;
  display: flex;

  &::v-deep .base-widget__content{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin: 6px;
    overflow: hidden;
  }

  .pencil {
    float: right;
    margin-right: .5rem;
  }

  &__avatar {
    margin: 0 .65rem 0 0;
  }

  &__subtitle {
    color: #646464;
    line-height: 1.25;
    letter-spacing: 0.168814px;
  }

  &__username {
    margin-bottom: 0.6rem;
    font-size: 17px;
    line-height: 1.25;
    letter-spacing: 0;
    width: 130px;
    font-family: $font-family-sans-serif;
  }

  &__bottom-slot {
    padding-top: 0.5rem;
  }
}
</style>
